import React from "react";
import { getResponsiveScreen } from "@redriver/cinnamon";
import { BackgroundContent, Heading, Panel } from "components/containers";
import { ScreenBreakpointNames } from "constants/breakpoints";
import { useSelector } from "react-redux";
import PageWrapper from "./PageWrapper";

const ImagePageWrapper = ({ title, children }) => {
  const screen = useSelector(getResponsiveScreen);
  const isSmallScreen = screen?.screenSize == ScreenBreakpointNames.Small;

  return (
    <PageWrapper>
      <BackgroundContent />
      <Panel floating isBlue={isSmallScreen}>
        {title && <Heading className="trip-details-header">{title}</Heading>}
        {children}
      </Panel>
    </PageWrapper>
  );
};

export default ImagePageWrapper;
